<template>
  <div class="pt-card">
    <div class="pt-card-header">
      <r-text>
        {{ titleText }}
      </r-text>
    </div>
    <pt-stoppoint-card
      v-if="mode === 'stop_points'"
      :draw="draw"
      :mapgl="mapgl"
      :state="state"
      :close-card="closeCard"
    />
    <pt-route-card
      v-else-if="mode === 'line_routes'"
      :draw="draw"
      :mapgl="mapgl"
      :state="state"
      :close-card="closeCard"
    />
  </div>
</template>

<script>
import PtStoppointCard from "./pt-stoppoint-card";
import PtRouteCard from "./pt-route-card";
import {
  clearReverseRouteStyling,
  clearActiveStopPointsStyling
} from "@/libs/map-draw/helpers";

export default {
  props: ["draw", "mapgl", "state", "mode"],
  components: {
    PtStoppointCard,
    PtRouteCard
  },
  watch: {
    "$store.state.publicTransport.mode": function() {
      this.closeCard();
    }
  },
  computed: {
    titleText() {
      return this.mode === "stop_points"
        ? "Карточка остановочного пункта"
        : "Карточка маршрута";
    }
  },
  methods: {
    closeCard() {
      this.$store.commit("SET_PT_STATE_PROP", {
        name: "activeCard",
        value: false
      });
      this.$store.commit("SET_PT_STATE_PROP", {
        name: "activeCardId",
        value: null
      });
      this.$store.commit("SET_ACTIVE_ROUTE_PROPS", {
        reverse: false,
        reverseRouteId: null
      });
      this.$store.commit("SET_PT_STATE_PROP", {
        name: "overlay",
        value: false
      });
      clearReverseRouteStyling(this.mapgl);
      clearActiveStopPointsStyling(this.mapgl, this.$store);
    }
  }
};
</script>

<style lang="scss">
.pt-card {
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  box-sizing: border-box;

  &-header {
    margin-bottom: 16px;
  }

  &-container {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  &-attributes {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  &-attribute {
    &:not(:first-child) {
      margin-top: 16px;
    }
  }
}
</style>
